module.exports = __webpack_public_path__ + "img/email.7a605a7d.svg";